import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { filter, take } from 'rxjs/operators';
import { environment } from '~env/environment';

@Component({
  selector: 'app-blocked-account',
  styleUrls: ['./blocked-account.component.scss'],
  templateUrl: './blocked-account.component.html',
})
export class BlockedAccountComponent {
  trans = { title: 'ERROR.403_PAGE.TITLE', message: 'ERROR.403_PAGE.MESSAGE', label: 'ERROR.403_PAGE.BUTTON_LABEL' };

  constructor(private router: Router, private accountInfoService: AccountInfoService) {
    this.isSplitPaymentObliged();
  }

  isSplitPaymentObliged() {
    this.accountInfoService
      .isSplitPaymentObliged()
      .pipe(take(1))
      .pipe(filter((isObliged) => isObliged))
      .subscribe((isObliged) => {
        if (isObliged) {
          this.trans = {
            title: 'ERROR.403_PAGE.OBLIGATION_TITLE',
            message: 'ERROR.403_PAGE.OBLIGATION_MESSAGE',
            label: 'ERROR.403_PAGE.OBLIGATION_BUTTON_LABEL',
          };
        }
      });
  }

  redirectToHelp(): void {
    window.open(environment.freshDeskUrl());
  }
}
